import { Injectable, OnInit } from '@angular/core';

import { CfButtonComponent } from '../../components/button/button.component';

import { DraggableService } from '../draggable-service/draggable.service';

const /** @type {?} */ COMP_PREFIX = 'cf_comp_';
const /** @type {?} */ PAGE_PREFIX = 'cf_page_';
/**
 * <p>Components storage service.</p>
 */
export class PageStorageService implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit(): void { }
/**
 * @param {?} compId
 * @param {?} compName
 * @param {?} compData
 * @param {?} pageId
 * @return {?}
 */
storeComponent(compId: string, compName: string, compData: any, pageId: string): void {
    // remove DynamicComponentLoader specific data, no need to store them
    let /** @type {?} */ compDataCopy = Object.assign({}, compData);
    delete compDataCopy.component;
    delete compDataCopy.loadedInstance;

    // prepare object to store
    let /** @type {?} */ pageDef = JSON.parse(localStorage.getItem(PAGE_PREFIX + pageId)) || {};
    pageDef.components = pageDef.components || {};

    let /** @type {?} */ compDef = pageDef.components[compId] || {};
    compDef.id = compId;
    compDef.name = compName;
    compDef.data = compDataCopy;
    pageDef.components[compId] = compDef;

    localStorage.setItem(PAGE_PREFIX + pageId, JSON.stringify(pageDef));
  }
/**
 * @param {?} compId
 * @param {?} compOptions
 * @return {?}
 */
storeComponentOptions(compId: string, compOptions: any): void {
    let /** @type {?} */ pageId = this.getPageId();

    let /** @type {?} */ pageDef = JSON.parse(localStorage.getItem(PAGE_PREFIX + pageId)) || {};
    pageDef.components = pageDef.components || {};

    let /** @type {?} */ compDef = pageDef.components[compId] || {};
    compDef.id = compId;
    compDef.options = compOptions;
    pageDef.components[compId] = compDef;

    localStorage.setItem(PAGE_PREFIX + pageId, JSON.stringify(pageDef));
  }
/**
 * @param {?} pageId
 * @return {?}
 */
getPageComponentsDefinitions(pageId: string): any[] {
    let /** @type {?} */ pageDef = JSON.parse(localStorage.getItem(PAGE_PREFIX + pageId)) || {};
    let /** @type {?} */ components = pageDef.components || {};

    let /** @type {?} */ pageCompsDefs = [];
    Object.keys(components).forEach((compId) => {
      pageCompsDefs.push(components[compId]);
    });
    return pageCompsDefs;
  }
/**
 * @param {?} compId
 * @param {?} pageId
 * @return {?}
 */
removeComponent(compId: string, pageId: string): void {
    let /** @type {?} */ pageDef = JSON.parse(localStorage.getItem(PAGE_PREFIX + pageId)) || {};

    if (pageDef.components) {
      delete pageDef.components[compId];
    }

    localStorage.setItem(PAGE_PREFIX + pageId, JSON.stringify(pageDef));
  }
/**
 * @return {?}
 */
getPageId(): string {
    return document.getElementsByTagName('body')[0].getAttribute('pageId');
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PageStorageService_tsickle_Closure_declarations() {
/** @type {?} */
PageStorageService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PageStorageService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
